var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 12,
        /* Optional */
        activeScrollToTop: true,
        // Color
        colorFilterOptionTitle: '',
        colorFilterOptionItem: '',
        colorClearButton: '',
        // Font size
        fontSizeFilterOptionTitle: '',
        fontSizeFilterOptionItem: '',
        fontSizeClearButton: ''
    },
    basic: {
        productsPerRow: 4,
        productsPerRowMobile: 2,
        showPrice: true,
        showVendor: true,
        showSaleLabel: true,
        showSoldOutLabel: true,
        activeImageSwap: true,
        showSorting: true,
        showLimit: true,
        // Color
        colorSaleLabel: '#e95144',
        borderColorSaleLabel: '#e95144',
        bgSaleLabel: '#fff',
        colorSoldOutLabel: '#d2d8db',
        borderColorSoldOutLabel: '#d2d8db',
        bgSoldOutLabel: '#fff',
    }
};


var grid_item_width = "large--one-quarter medium--one-half";

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout label" {[style]}>' + bcSfFilterConfig.label.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale label" {[style]}>' + bcSfFilterConfig.label.sale + '</span>',
    'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{[itemVendorLabel]}</p>',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item {[grid_item_width]} text-center">' +
                              '<a href="{[itemUrl]}" class="grid__image">' +
                                '<img src="{[imgUrl]}" alt="{[itemTitle]}">' +
                              '</a>' +
                              '<p class="h4">' +
                                '<a href="{[itemUrl]}">{[itemTitle]}</a>' +
                              '</p>' +
  							  '<p>' +
                              '{[priceHtml]}' +
                              '</p><br>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{[itemUrl]}">« Previous</a></span>',
  	'previousDisabledHtml': '',
    'nextActiveHtml': '<span class="next"><a href="{[itemUrl]}">Next »</a></span>',
  	'nextDisabledHtml': '',
    'pageItemHtml': '<span class="page"><a href="{[itemUrl]}">{[itemTitle]}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{[itemTitle]}</span>',
    'pageItemRemainHtml': '<span class="deco">{[itemTitle]}</span>',
    'paginateHtml': '<div class="pagination">{[previous]}{[pageItems]} {[next]}</div>',
  
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select class="bc-sf-filter-filter-dropdown">{[sortingItems]}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{[showLimitItems]}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {[breadcrumbDivider]} {[breadcrumbItems]}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{[itemLink]}">{[itemTitle]}</a>',
    'breadcrumbItemSelected': '<span>{[itemTitle]}</span>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Add Custom class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{\[soldOutClass\]}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{\[saleClass\]}/g, saleClass);

    // Add Grid Width class
    itemHtml = itemHtml.replace(/{\[grid_item_width\]}/g, grid_item_width);

    // Add Images
    itemHtml = itemHtml.replace(/{\[imgUrl\]}/g, buildImages(data));

    // Add Price
    itemHtml = itemHtml.replace(/{\[priceHtml\]}/g, buildPrice(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{\[itemId\]}/g, data.id);
    itemHtml = itemHtml.replace(/{\[itemTitle\]}/g, data.title);
    itemHtml = itemHtml.replace(/{\[itemHandle\]}/g, data.handle);
    itemHtml = itemHtml.replace(/{\[itemVendorLabel\]}/g, data.vendor);
    itemHtml = itemHtml.replace(/{\[itemUrl\]}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Featured Image
        var images = Object.keys(data[k].images).map(function (key) { return data[k].images[key]; });
        var featuredImage = images.length > 0 ? images[0] : bcSfFilterConfig.general.no_image_url;
        data[k]['featured_image'] = featuredImage;

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

function prepareShopifyData(data) {
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

function buildGridWidthClass() {
    var gridWidthClass = '';
    // On PC
    switch (bcsffilter.getSettingValue('basic.productsPerRow')) {
        case 2: gridWidthClass = 'bc-sf-filter-grid-width-2'; break;
        case 3: gridWidthClass = 'bc-sf-filter-grid-width-3'; break;
        case 5: gridWidthClass = 'bc-sf-filter-grid-width-5'; break;
        default: gridWidthClass = 'bc-sf-filter-grid-width-4'; break;
    }    
    // On Mobile
    switch (bcsffilter.getSettingValue('basic.productsPerRowMobile')) {
        case 1: gridWidthClass += ' bc-sf-filter-grid-width-mb-1'; break;
        case 3: gridWidthClass += ' bc-sf-filter-grid-width-mb-3'; break;
        default:  gridWidthClass += ' bc-sf-filter-grid-width-mb-2'; break;
    }
    return gridWidthClass;
}
function buildImages(data) {
    // Build Main Image
    var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    return thumbUrl;
}
function buildVendor(data) {
    var html = '';
    if (bcsffilter.getSettingValue('basic.showVendor')) {
        html = bcSfFilterTemplate.vendorHtml;
    }
    return html;
}
function buildPrice(data) {
    var html = '';

    if(onSale){
        if(priceVaries){
            var sale_price = bcsffilter.formatMoney(data.price_min,bcsffilter.moneyFormat);
            var on_sale_from_html = "<strong>On Sale</strong> from  ";            
            html += on_sale_from_html + sale_price;
        }else{
            html += "<strong>On Sale</strong>";
            html += bcsffilter.formatMoney(data.price_min,bcsffilter.moneyFormat);
        }

    }else{
        if(priceVaries){
            var price = bcsffilter.formatMoney(data.price_min,bcsffilter.moneyFormat);
            var from_text_html = "From  ";
            html += from_text_html + price;
        }else{
            html += bcsffilter.formatMoney(data.price_min,bcsffilter.moneyFormat);
        }
    }
    if(soldOut){
        html += "<br><strong>Sold Out</strong>";
    }
    if(onSale){
        html += '<span class="visually-hidden"> Regular price </span>';
        html += "<br><s>" + bcsffilter.formatMoney(data.compare_at_price_min,bcsffilter.moneyFormat) + "</s>";
    }
  if (data.tags.indexOf('enquire') > -1) {
    html = '';
  }
  return html;
}
function buildLabels(data) {
    // Build Sold out label
    var soldOutLabel = '';
    if (bcsffilter.getSettingValue('basic.showSoldOutLabel') && soldOut) {
        var color = 'color: ' + bcsffilter.getSettingValue('basic.colorSoldOutLabel') + ';';
        var border = ' border: 1px solid ' + bcsffilter.getSettingValue('basic.borderColorSoldOutLabel') + ';';
        var bg = ' background: ' + bcsffilter.getSettingValue('basic.bgSoldOutLabel') + ';';
        var style = 'style="' + color + border + bg + '";';
        soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{\[style\]}/g, style);
    }
    // Build Sale label
    var saleLabel = '';
    if (bcsffilter.getSettingValue('basic.showSaleLabel') && onSale && !soldOut) {
        var color = 'color: ' + bcsffilter.getSettingValue('basic.colorSaleLabel') + ';';
        var border = ' border: 1px solid ' + bcsffilter.getSettingValue('basic.borderColorSaleLabel') + ';';
        var bg = ' background: ' + bcsffilter.getSettingValue('basic.bgSaleLabel') + ';';
        var style = 'style="' + color + border + bg + '";';
        saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{\[style\]}/g, style);
    }
    // Build Labels
    var html = soldOutLabel + saleLabel;
    return html
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

/************************** BUILD TOOLBAR **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{\[itemUrl\]}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{\[previous\]}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{\[itemUrl\]}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{\[next\]}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{\[itemTitle\]}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{\[itemUrl\]}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{\[pageItems\]}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (this.getSettingValue('basic.showSorting') && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{\[sortingItems\]}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);
            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (this.getSettingValue('basic.showLimit') && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
        jQ(this.selector.topShowLimit).html('');

        var numberList = this.getSettingValue('general.showLimitList');
        if (numberList != '') {
            // Build content
            var showLimitItemsHtml = '';
            var arr = numberList.split(',');
            for (var k = 0; k < arr.length; k++) {
                showLimitItemsHtml += '<option value="' + arr[k].trim() +'">' + arr[k].trim() + '</option>';
            }
            var html = bcSfFilterTemplate.showLimitHtml.replace(/{\[showLimitItems\]}/g, showLimitItemsHtml);
            jQ(this.selector.topShowLimit).html(html);
            // Set value
            jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(data, colData, apiData) {
    if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
        var breadcrumbItemsHtml = '';
        if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
            var colInfo = data.collection;
            if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{\[itemLink\]}/g, '/collections/' + colInfo.handle).replace(/{\[itemTitle\]}/g, colInfo.title);
                breadcrumbItemsHtml += " {[breadcrumbDivider]} ";
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{\[itemTitle\]}/g, this.collectionTags[0]);
            } else {
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{\[itemTitle\]}/g, colInfo.title);
            }
        } else {
            breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{\[itemTitle\]}/g, this.getSettingValue('label.defaultCollectionHeader'));
        }
        var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{\[breadcrumbItems\]}/g, breadcrumbItemsHtml)
        html = html.replace(/{\[breadcrumbDivider\]}/g, bcSfFilterTemplate.breadcrumbDivider);
        jQ(this.selector.breadcrumb).html(html);
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    matchHeightImage();
    jQ(window).resize(function(){
        matchHeightImage();
    })

    // Build Image Swap
    if (this.getSettingValue('basic.activeImageSwap')) buildImageSwap();
};

function matchHeightImage() {
    jQ('.bc-sf-filter-product-item').each(function(){
        var mainImage = jQ(this).find('.bc-sf-filter-product-item-main-image');
        var imageContainer = jQ(this).find('.bc-sf-filter-product-item-image');
        mainImage.one('load', function() {
            imageContainer.css('width', '100%').css('height', mainImage.height());
        }).each(function() {
            if(this.complete) jQ(this).load();
        });
    });
}

// Build Image Swap
function buildImageSwap() {
    jQ('.bc-sf-filter-product-item-image').each(function() {
        jQ(this).children('img').css({
            'position': 'absolute',
            'top': 0,
            'left': 0,
            'width': '100%'
        })
    });
    jQ('.bc-sf-filter-product-item-main-image').hover(function() {
        jQ(this).css('opacity', 0);
        jQ(this).siblings().show();
    }, function() {
        jQ(this).css('opacity', 1);
        jQ(this).siblings().hide();
    });
}